const parseCookie = str =>
  str
  .split(';')
  .map(v => v.split('='))
  .reduce((acc, v) => {
    acc[decodeURIComponent(v[0].trim())] = decodeURIComponent(v[1].trim());
    return acc;
  }, {});
  const parseQuery = str =>
  str
  .split('&')
  .map(v => v.split('='))
  .reduce((acc, v) => {
    acc[decodeURIComponent(v[0].trim())] = decodeURIComponent(v[1].trim());
    return acc;
  }, {});
const cookies = parseCookie(document.cookie);
const query = parseQuery(location.search||"");

if (query && query['utm_term']) {
  document.cookie=`utm_term=${query['utm_term']}`;
}